import { LatLngLiteral } from './components/googlemaps/Common';

export type Ext = {
    empty: string;
};

export interface LocationInfo {
    address: string;
    coordinates: LatLngLiteral;
}

export const getAddressFromLoactionInfo = (locationInfo: any): string => {
    if (!locationInfo) {
        return '';
    }

    if (typeof locationInfo === 'object') {
        if (!!locationInfo.address) {
            return locationInfo.address;
        }
    }
    return '';
};

export const formatNumber = (number?: number): string => {
    if (number === undefined) {
        return '';
    }
    const formatter = new Intl.NumberFormat('sr-RS');

    const formattedNumber = formatter.format(number);

    return formattedNumber;
};

export const formatNumberToTwoDigits = (number?: number): string => {
    if (number === undefined) {
        return '00';
    }

    if (number < 10) {
        return '0' + number.toString();
    }

    return number.toString();
};

export const generateWaybillNumber = (): string => {
    const newDate = new Date();
    return (
        'OTP-' +
        formatNumberToTwoDigits(newDate.getMonth() + 1) +
        formatNumberToTwoDigits(newDate.getDate()) +
        '/' +
        (newDate.getFullYear() % 100).toString() +
        '-' +
        formatNumberToTwoDigits(newDate.getHours()) +
        formatNumberToTwoDigits(newDate.getMinutes())
    );
};

/** Google Maps pretraga za adresu, otvara se u aplikaciji Mape na telefonu. */
export const mapsSearchUrl = (address?: string): string | undefined => {
    return address && address.trim() !== ''
        ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address.trim())
        : undefined;
};

/** `tel:` link bez razmaka i crtica, da telefon može odmah da pozove. */
export const telUrl = (phone?: string): string | undefined => {
    const digits = (phone ?? '').replace(/[^\d+]/g, '');
    return digits !== '' ? 'tel:' + digits : undefined;
};
